import { Component, Input, OnInit } from '@angular/core';
import { BaseModal } from '@ui-app/modals/base-modal';

@Component({
    selector: 'employee-ui-name-change-modal',
    templateUrl: './name-change-modal.component.html',
    styleUrls: ['./name-change-modal.component.less']
})
export class NameChangeModalComponent extends BaseModal implements OnInit {
    @Input() buttonsTitle = {
        close: 'Close'
    };
    @Input() isUSI: boolean;

    beginningOfText = 'To change your name on your badge, please email STO';
    endOfText = 'to submit a name change.';
    email = 'USNationalSTO@deloitte.com';

    BEGINNING_OF_USI_TEXT = 'To Change your Name - Go to Talent On Demand and initiate a name change and once it is approved by Talent ' +
        'then send an email to STO badging at';
    USI_EMAIL = 'ushydbadging@deloitte.com';
    END_OF_USI_TEXT = 'for name change on badge';

    ngOnInit(): void {
        if (this.isUSI) {
            this.beginningOfText = this.BEGINNING_OF_USI_TEXT;
            this.endOfText = this.END_OF_USI_TEXT;
            this.email = this.USI_EMAIL;
        }
    }
}
